// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18u0u2gc{margin-left:var(--ds-space-100,8px)}\n._19pkze3t{margin-top:var(--ds-space-0,0)}\n._1bsbt94y{width:1px}\n._1e0c1o8l{display:inline-block}\n._2hwxu2gc{margin-right:var(--ds-space-100,8px)}\n._4t3i1tcg{height:24px}\n._bfhkplhp{background-color:var(--ds-background-neutral-hovered,#0b120e24)}\n._otyrze3t{margin-bottom:var(--ds-space-0,0)}\n._uiztglyw{-webkit-user-select:none;-ms-user-select:none;user-select:none}", ""]);
// Exports
module.exports = exports;
